<template>
  <div class="card">
    <div class="card-content">
      <div class="row">
        <div class="col-xs-5">
          <slot name="header"></slot>
        </div>
        <div class="col-xs-8">
          <slot name="content"></slot>
        </div>
      </div>
      <div class="row">
        <div class="col-xs-4 col-md-4 he">
          Inicial
        </div>
         <div class="col-xs-4 col-md-4 he">
          Anual
        </div>
         <div class="col-xs-4 col-md-4 he">
          Final
        </div>    
        <div class="col-xs-4 col-md-4 he">
          <slot name="inicial"></slot>
        </div>
         <div class="col-xs-4 col-md-4 he">
          <slot name="anual"></slot>
        </div>
         <div class="col-xs-4 col-md-4 he">
          <slot name="final"></slot>
        </div>

      </div>
    </div>
  </div>
</template>
<script>
  export default {
    name: 'stats-card'
  }

</script>
<style scoped>
  .card-content{
    min-height: 85px !important;
  }

   .col-xs-8{
    min-height: 85px !important;
    text-align: right !important;
  }
  .col-xs-5{
    padding-right: 10px !important;
    padding-left: 50px !important;
  }
  .col-xs-4{
    font-weight: bold !important;
    padding: 5px !important;
    text-align: center !important;
  }
  .col-md-4{
    font-weight: bold !important;
    padding: 5px !important;
    text-align: center !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/UIComponents/Cards/StatsCard2.vue